import { useEffect, useMemo, useState } from "react";

// Utils
import { client } from "lib/Contentful/Contentful";

// Hooks
const useContentfulData = (contentType, page = null, filters = {}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const filtersKey = useMemo(() => JSON.stringify(filters ?? {}), [filters]);
  const stableFilters = useMemo(() => JSON.parse(filtersKey), [filtersKey]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const queryFilters = {
          content_type: contentType,
          ...stableFilters,
        };
        const content = await client.getEntries(queryFilters);

        setData(content.items);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [contentType, page, filtersKey, stableFilters]);

  return { data, loading, error };
};

export default useContentfulData;
